import Api from '@/services/Api'

export default {
    getCodigoCompania(idCompania){
        return Api().get('getCodigoCompania/'+idCompania)
    },
    getNotasEF(codReporte,idCompania,vigencia,clase){
        return Api().get('getNotasEF/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+clase)
    },
    getNotas(idCompania,vigencia,numero){
        return Api().get('getNotas/'+idCompania+'/'+vigencia+'/'+numero)
    },
    getTodasNotas(idCompania,vigencia){
        return Api().get('getTodasNotas/'+idCompania+'/'+vigencia)
    },
    leeTasas(vigencia){
        return Api().get('leeTasas/'+vigencia)
    },
    getBalanceNiif(codReporte,idCompania,vigencia){
        return Api().get('balanceNiif/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getBalanceNiifConsol(codReporte,idCompania,vigencia){
        return Api().get('balanceNiifConsol/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getBalanceNiifCompar(codReporte,idCompania,vigencia){
        return Api().get('balanceNiifCompar/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getCompanias(individual){
        return Api().get('getCompanias/'+individual)
    },
    getFechas(){
        return Api().get('getFechas')
    },
    getReportes(){
        return Api().get('getReportes')
    },
    getReporteEsf(codReporte,idCompania,vigencia){
        return Api().get('ReporteEsf/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEsfConsol(codReporte,idCompania,vigencia){
        return Api().get('ReporteEsfConsol/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEsfCompar(codReporte,idCompania,vigencia){
        return Api().get('ReporteEsfCompar/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEri(codReporte,idCompania,vigencia){
        return Api().get('ReporteEri/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEriConsol(codReporte,idCompania,vigencia){
        return Api().get('ReporteEriConsol/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEriCompar(codReporte,idCompania,vigencia){
        return Api().get('ReporteEriCompar/'+codReporte+'/'+idCompania+'/'+vigencia)
    },
    getReporteEfe(idCompania,vigencia,codReporte){
        return Api().get('ReporteEfe/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEfeDirecto(idCompania,vigencia,codReporte,nivel,consolidado){
        return Api().get('ReporteEfeDirecto/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+nivel+'/'+consolidado)
    },
    getReporteEfeIndirecto(idCompania,vigencia,codReporte,nivel,consolidado){
        return Api().get('ReporteEfeIndirecto/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+nivel+'/'+consolidado)
    },
    getReporteInformacion(idCompania,vigencia,codReporte,directo,u_crea){
        return Api().get('ReporteInformacion/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+directo+'/'+u_crea)
    },
    getReporteEcpInformacion(idCompania,vigencia,codReporte,u_crea){
        return Api().get('ReporteEcpInformacion/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+u_crea)
    },
    grabaInformacion(idCompania,vigencia,codReporte,form){
        console.log(form)
        return Api().post('GrabaInformacion/'+idCompania+'/'+vigencia+'/'+codReporte,form)
    },
    grabaEcpInformacion(idCompania,vigencia,codReporte,form){
        return Api().post('GrabaEcpInformacion/'+idCompania+'/'+vigencia+'/'+codReporte,form)
    },
    getReporteEcp(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcp/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpConsol(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpConsol/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpCompar(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpCompar/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpFinal(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpFinal/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getReporteEcpFinalConsol(idCompania,vigencia,codReporte){
        return Api().get('ReporteEcpFinalConsol/'+idCompania+'/'+vigencia+'/'+codReporte)
    },
    getEliminaciones(codReporte,vigencia,opcion){
        return Api().get('getEliminaciones/'+codReporte+'/'+vigencia+'/'+opcion)
    },
    getEliminaOrigen(vigencia,secuencia){
        return Api().get('getEliminaOrigen/'+vigencia+'/'+secuencia)
    },
    getEliminaDestino(vigencia,secuencia){
        return Api().get('getEliminaDestino/'+vigencia+'/'+secuencia)
    },
    grabeAjuste(tabla,form){
        return Api().post('grabeAjuste/'+tabla, form)
    },
    elimineAjuste(tabla,form){
        return Api().post('elimineAjuste/'+tabla, form)
    },
    getValorAjustar(vigencia,secuencia){
        return Api().get('getValorAjustar/'+vigencia+"/"+secuencia)
    },
    grabeContraAjuste(form){
        return Api().post('grabeContraAjuste', form)
    },
    getAjustesTopside(idCompania,vigencia,codReporte,tipo_ajuste){
        return Api().get('getAjustesTopside/'+idCompania+'/'+vigencia+'/'+codReporte+'/'+tipo_ajuste)
    },
    getCuentas(idCompania,vigencia){
        return Api().get('getCuentas/'+idCompania+'/'+vigencia)
    },
    getCuentasNiif(codReporte,idCompania,vigencia,niif){
        return Api().get('getCuentasNiif/'+codReporte+'/'+idCompania+'/'+vigencia+'/'+niif)
    },
    getNiif(vigencia,idCompania){
        return Api().get('getNiif/'+idCompania+'/'+vigencia)
    },
    getSaldoNiif(idCompania,vigencia,cuenta,niif){
        return Api().get('getSaldoNiif/'+idCompania+'/'+vigencia+'/'+cuenta+'/'+niif)
    },
    grabeAjusteTopside(idCompania,vigencia,form){
        return Api().post('grabeAjusteTopside/'+idCompania+'/'+vigencia, form)
    },
    borraAjusteTopside(idCompania,vigencia,secuencia,tipo_ajuste){
        return Api().post('borraAjusteTopside/'+idCompania+'/'+vigencia+'/'+secuencia+'/'+tipo_ajuste)
    },
    getEcpFilas(){
        return Api().get('getEcpFilas')
    },
    getEcpColumnas(){
        return Api().get('getEcpColumnas')
    },
    ingresaElimAjusteOrig(dataOrig){
        return Api().post('insertElimAjusteOrig',dataOrig)
    },
    ingresaElimAjusteDest(dataOrig){
        return Api().post('insertElimAjusteDest',dataOrig)
    },
    getTBA(idCompania,vigencia,numero,parrafo){
        return Api().get('getTBA'+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTBT(idCompania,vigencia,numero,parrafo){
        return Api().get('getTBT'+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTBC(idCompania,vigencia,numero,parrafo){
        return Api().get('getTBC'+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTNA(idCompania,vigencia,numero,parrafo){
        return Api().get('getTNA'+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTNT(idCompania,vigencia,numero,parrafo){
        return Api().get('getTNT'+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    getTNC(idCompania,vigencia,numero,parrafo){
        return Api().get('getTNC'+'/'+idCompania+'/'+vigencia+'/'+numero+'/'+parrafo)
    },
    grabeNotaParrafo(parrafo) {
        return Api().post('grabeNotaParrafo',parrafo)
    },
    genereEliminaciones(codReporte,vigencia,secuencia) {
        return Api().get('genereEliminaciones'+'/'+codReporte+'/'+vigencia+'/'+secuencia)
    },
    leaCompaniaUsuario(){
        return Api().get('leaCompaniaUsuario')
    },
}
